import React, { useState, useEffect } from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import CardActionArea from '@material-ui/core/CardActionArea'
import { connect } from "react-redux"
import CardContent from '@material-ui/core/CardContent'
import Input from '@material-ui/core/Input'
import TopBarNav from '../common/TopBarNav'
import { useHistory } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import { getUploadEvidenceTableTitle, getUploadEvidenceTableColumns } from "../common/Utils"
import { MaintenanceStylesEvidence } from './MaintenanceStyles'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import * as maintenanceActions from '../../actions/maintenance/MaintenanceActions'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { Backdrop, CircularProgress } from '@material-ui/core'

const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }

const MaintenanceUploadEvidence = ({ classes, ...props }) => {
    const history = useHistory()
    const [option, setOption] = useState('UnitPhotos')
    const [file, setFile] = useState()
    const [open, setOpen] = useState(false)
    const { match: { params } } = props
    const [idDeleteFile, setIdDeleteFile] = useState(null)
    const [evidenceType, setEvidenceType] = useState('Foto')

    const [buttonUnitPhotos, setButtonUnitPhotos] = useState(classes.GridBorderSelected)
    const [buttonDocumentsPhotos, setButtonDocumentsPhotos] = useState(classes.GridBorder)
    const [buttonVideos, setButtonVideos] = useState(classes.GridBorder)
    const [textUnit, setTextUnit] = useState(classes.TextSelected)
    const [textDocument, setTextDocument] = useState(classes.Text)
    const [textVideo, setTextVideo] = useState(classes.Text)
    const [openBackdrop, setOpenBackdrop] = useState(false)

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fecth_Evidence(props.userLanguage, props.userToken, params.orderId, option, onError, onSuccessFetch)
    }, [option]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/maintenance/UploadEvidence',
            linkLegend: 'Subir Evidencia',
            urlParams: [{ key: 'orderId', value: params.orderId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Order_Detail(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccessFetch = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const ChangeOption = (e) => {
        Array.from(document.querySelectorAll("input")).forEach(
            input => (input.value = "")
        );
        setFile(null)
        setOption(e)

        switch (e) {
            case 'UnitPhotos':
                setButtonUnitPhotos(classes.GridBorderSelected)
                setButtonDocumentsPhotos(classes.GridBorder)
                setButtonVideos(classes.GridBorder)
                setEvidenceType('Foto')

                setTextUnit(classes.TextSelected)
                setTextDocument(classes.Text)
                setTextVideo(classes.Text)
                break;
            case 'DocumentsPhotos':
                setButtonUnitPhotos(classes.GridBorder)
                setButtonDocumentsPhotos(classes.GridBorderSelected)
                setButtonVideos(classes.GridBorder)
                setEvidenceType('Foto')

                setTextUnit(classes.Text)
                setTextDocument(classes.TextSelected)
                setTextVideo(classes.Text)
                break;
            case 'Videos':
                setButtonUnitPhotos(classes.GridBorder)
                setButtonDocumentsPhotos(classes.GridBorder)
                setButtonVideos(classes.GridBorderSelected)
                setEvidenceType('Video')

                setTextUnit(classes.Text)
                setTextDocument(classes.Text)
                setTextVideo(classes.TextSelected)
                break;
            default:
                break;
        }
    }

    const onChangeHandler = event => {
        if (checkFileType(event)) {
            setFile(event.target.files[0])
        } else {
            setFile(null)
        }
    }

    const checkFileType = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = []

            switch (option) {
                case "UnitPhotos":
                    types = ['image/png', 'image/jpeg', 'image/jpg']
                    break;
                case 'DocumentsPhotos':
                    types = ['image/png', 'image/jpeg', 'image/jpg']
                    break;
                case 'Videos':
                    types = ['video/mp4']
                    break;
                default:
                    break;
            }

            if (types.every(type => file.type !== type)) {
                toast.error(file.type + " Formato no soportado", { className: classes.toastError })
                event.target.value = null
                return false
            } else {
                return true
            }
        }
    }

    const SendFile = () => {
        if (file != null) {
            handleOpenBackdrop()
            const formData = new FormData();
            formData.append('formFile', file);
            props.actions.Update_Evidence(props.userLanguage, props.userToken, params.orderId, formData, option, onError, onSuccess)

            Array.from(document.querySelectorAll("input")).forEach(
                input => (input.value = "")
            )
            setFile(null)
        } else {
            toast.info("Selecciona un archivo")
        }
    }

    const DeleteEvidence = () => {
        handleOpenBackdrop()
        props.actions.delete_Evidence(props.userLanguage, props.userToken, idDeleteFile, params.orderId, option, onError, onSuccessDelete)
        setOpen(false);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
        toast.success('Se agregó correctamente la evidencia', { className: classes.toastSuccess })
    }

    const onSuccessDelete = () => {
        handleCloseBackdrop()
        toast.success('Se eliminó correctamente la evidencia', { className: classes.toastSuccess })
    }

    const showButtonDeleteAux = (e) => {
        setIdDeleteFile(e)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <TopBarNav />
            <br />

            <Container maxWidth="lg" >
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container>
                    <Grid item xs={4} style={{ marginLeft: '-25px' }}>
                        <BreadcrumbsHistory />
                    </Grid>
                    <Grid item xs={8}>
                        <h5>Detalles de la orden de trabajo Subir evidencia</h5>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="lg" className={classes.root}>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                        <br />
                        <h6>Autorización: {params.orderId}</h6>
                        <h6>VIN: {props.orderDetail.vin}</h6>
                        <br />
                    </Grid>
                </Grid>

                <Grid container item xs={11} className={classes.ContainerBorder} >
                    <Grid item xs={3} className={classes.ContainerOptionBorder} >
                        <CardActionArea className={buttonUnitPhotos} onClick={(e) => ChangeOption("UnitPhotos")} style={{ marginBottom: '5px' }}>
                            <CardContent className={classes.dashboardAlign}>
                                <h5 className={textUnit}>Fotos de la Unidad</h5>
                            </CardContent>
                        </CardActionArea>

                        <CardActionArea className={buttonDocumentsPhotos} onClick={(e) => ChangeOption("DocumentsPhotos")} style={{ marginBottom: '5px' }}>
                            <CardContent className={classes.dashboardAlign}>
                                <h5 className={textDocument}>Fotos de documentos</h5>
                            </CardContent>
                        </CardActionArea>

                        <CardActionArea className={buttonVideos} onClick={(e) => ChangeOption("Videos")}>
                            <CardContent className={classes.dashboardAlign}>
                                <h5 className={textVideo}>Video de evidencia</h5>
                            </CardContent>
                        </CardActionArea>
                    </Grid>
                    <Grid item xs={9} >
                        <Container maxWidth="lg" >
                            <Grid item xs={12} >
                                <h4 className={classes.titleTable}>{getUploadEvidenceTableTitle(option)}</h4>
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <Grid container item xs={12}>
                                        <Grid item xs={8}>
                                            <div className="form-group files">
                                                <label>{evidenceType} &nbsp;&nbsp;</label>
                                                <Input type="file" name="file" id="file" onChange={onChangeHandler} />
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                                                <Button type="button" className={classes.ButtonSave} variant="outlined" onClick={SendFile}>Guardar</Button>
                                            </ButtonGroup>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <br />
                                <DataTable
                                    columns={getUploadEvidenceTableColumns(option, { showButtonDeleteAux })}
                                    data={props.listEvidence}
                                    defaultSortField=""
                                    noHeader={true}
                                    dense
                                    highlightOnHover
                                    pointerOnHover
                                    pagination
                                    paginationComponentOptions={paginationOptions}
                                />
                            </Grid>
                            <br />
                        </Container>
                    </Grid>
                </Grid>
                <br />
                <br />
            </Container>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"¿Desea eliminar el registro?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Al dar clic en el botón de "ELIMINAR", se elminará de manera permanente la evidencia seleccionada
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={DeleteEvidence} color="primary">
                        ELIMINAR
                </Button>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        CANCELAR
                </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer />
        </div>
    )

}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    listEvidence: state.MaintenanceReducer.evidence,
    orderDetail: state.MaintenanceReducer.orderDetail,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(maintenanceActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(MaintenanceStylesEvidence)(MaintenanceUploadEvidence))